import { render, staticRenderFns } from "./TournamentModule.vue?vue&type=template&id=701acbdc&"
import script from "./TournamentModule.vue?vue&type=script&lang=js&"
export * from "./TournamentModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports